


import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { phoneNumberValidator } from 'src/app/shared/validators/phone-number.validator';
import { TaxpayerModalComponent } from 'src/app/admin/pages/taxpayer/taxpayer-modal/taxpayer-modal.component';
import { Location } from '@angular/common';
import { TransportAssetDetailsModalComponent } from '../transport-asset-details-modal/transport-asset-details-modal.component';

export function toTitleCase(text: string): string {
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

function removeUnderscore(str) {
  return str.replace(/_/g, ' ');  // Remove all underscores
}

function formatUnderscoredValue(str) {
  return str
    .replace(/_/g, ' ')          // Replace underscores with spaces
    .split(' ')                  // Split into words by space
    .map(word =>                 // Capitalize each word
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ');                  // Join the words back with spaces
}


export function sortObjectsByKey<T>(list: T[], key: keyof T): T[] {
  return list.sort((a, b) => a[key].toString().localeCompare(b[key].toString()));
}

@Component({
  selector: 'app-transport-asset-details-page',
  standalone: false,
  templateUrl: './transport-asset-details-page.component.html',
  styleUrl: './transport-asset-details-page.component.scss'
})
export class TransportAssetDetailsPageComponent {
  form: FormGroup;
  isDarkMode!: boolean;

  details: any;


  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  itemList: any[] = [];
  isListUpdated = false;


  vehicleTypes: any[] = [];

  rememberMe: boolean;


  id: number;
  isInEditingMode: boolean = false;

  assessmentTypes: any[];
  profilingTypes: any[];
  categories: any[];
  navigationData: any;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private apiService: ApiService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,

  ) { }

  ngOnInit(): void {
    this.initForm();

    const queryParams = this.route.snapshot.queryParams;

    this.navigationData = this.router.getCurrentNavigation()?.extras?.state;


    this.id = queryParams.id;


    this.getAllVehicleTypes();


    this.form.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.form.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });

    this.rememberMe = false;

    this.isInEditingMode = Boolean(this.navigationData?.isInEditingMode);

    if (!this.isInEditingMode) {
      this.form.disable()
    }



    if (this.id) {
      this.fetchDetails(this.id)
    }

    this.subscribeToprofilingTypeControl()
    this.fetchProfilingTypes()


  }


  goBack() {
    this.location.back();
  }


  initForm(): void {
    this.form = this.fb.group({
      // assessmentType: [null, [Validators.required]],
      profilingType: [null, [Validators.required]],
      category: [null, [Validators.required]],
    });




  }



  // get assessmentTypeControl(): FormControl {
  //   return this.form.get('assessmentType')! as FormControl
  // }

  get profilingTypeControl(): FormControl {
    return this.form.get('profilingType')! as FormControl
  }
  get categoryControl(): FormControl {
    return this.form.get('category')! as FormControl
  }



  fetchProfilingTypes() {

    this.apiService
      .get(`/utility/profiling-type`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.profilingTypes = response.map(item => ({ ...item, disabled: false }));

      });
  }





  fetchCategories(profilingTypeId: number) {
    this.categories = null;
    this.categoryControl.reset()
    this.apiService
      .get(`/utility/profiling-category?profilingTypeId=${profilingTypeId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {

        this.categories = response;
      });
  }

  subscribeToprofilingTypeControl() {
    this.profilingTypeControl.valueChanges.subscribe((category: any) => {
      if (category) {
        this.fetchCategories(category);
      }
    })
  }

  // subscribeToAssessmentTypeControl() {
  //   this.assessmentTypeControl.valueChanges.subscribe((assessmentType: any) => {
  //     if (assessmentType) {
  //       this.fetchProfilingTypes(assessmentType);
  //     }
  //   })
  // }



  allowEditing() {
    this.isInEditingMode = true;
    this.form.enable()
  }

  fetchDetails(transportId: number) {
    this.details = null;


    this.apiService
      .get(`/transport/detail/${transportId}`)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.details = response.data;


        this.mapFormValues(response?.data)
      });
  }

  mapFormValues(data: any) {
    this.form.patchValue({
      phoneNumber: data?.phoneNumber,
      address: data?.address
    })
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data?.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  closeModal(): void {
    if (!this.isSubmitting) {
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  editTaxpayer() {
    let dialogRef = this.dialog.open(TransportAssetDetailsModalComponent, {
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'custom-dialog-lg'],
      disableClose: true,

      data: this.details,
    });

    dialogRef.afterClosed().subscribe((data: any) => {
      if(data.reload ==  true){
        this.fetchDetails(this.id)
      }
    })
  }






  markListAsUpdated() {
    this.isListUpdated = true;
  }

  addItemToList(): void {
    const formValues = this.form.value;



    if (this.form.valid) {


      const categoryAlreadyAdded = this.itemList.find((item) => item?.profilingType?.id == formValues?.profilingType && item?.category?.id == formValues?.category)

      if (Boolean(categoryAlreadyAdded)) {
        this.categoryControl.setErrors({ duplicateEntry: categoryAlreadyAdded.category.revenueDescription });
        this.showErrorMessages = false;
        return;
      }



      const profilingType = this.profilingTypes.find((item: any) => item.id == formValues?.profilingType);
      const category = this.categories.find((item: any) => item.id == formValues?.category);




      this.itemList.push({ profilingType, category });



      this.markListAsUpdated()
      this.form.reset();
      this.showErrorMessages = false;


      if (profilingType.id != 1) { //Disable added profiling type(Except for licenses, for which duplicate entries are allowed)
        profilingType.disabled = true;
        this.profilingTypes = [...this.profilingTypes];
      }
    } else {
      this.showErrorMessages = true
    }
  }

  removeItem(index: number, item: any): void {
    this.itemList.splice(index, 1);

    const profilingType = this.profilingTypes.find((pt) => pt.id === item.profilingType.id);
    if (profilingType) {
      profilingType.disabled = false;
      this.profilingTypes = [...this.profilingTypes];
    }

    this.markListAsUpdated()
  }

  createUserProfile(): void {
    this.isSubmitting = true;
    this.form.disable();

    const formValues = this.form?.value;

    const request = {
      asin: this.details?.asin,
      requests: this.itemList.map((item) => ({ amount: item.category.amount, profilingType: item.profilingType.id, profilingCategory: item.category.id }))
      // parkId
    };

    this.apiService
      .post(`/taxpayer/create`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }

  updateUser(): void {
    this.isSubmitting = true;
    this.form.disable();

    const formValues = this.form?.value;

    const request = {
      asin: this.details?.asin,
      requests: this.itemList.map((item) => ({ amount: item.category.amount, profilingType: item.profilingType.id, profilingCategory: item.category.id }))
      // parkId
    };

    this.apiService
      .post(`/taxpayer/update`, request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
